import React from 'react';

import { DATA_HC_NAME_REPORT_SUMMARY_TABLE_CELL } from '../../../constants/ReportSummary.constants';
import { ReportSummaryCellContentProps } from '../../../types';

import { createReportSummaryTableCellConfig } from './ReportSummaryTableCell';

const dataHcName = `${DATA_HC_NAME_REPORT_SUMMARY_TABLE_CELL}-product-type`;
// eslint-disable-next-line react-refresh/only-export-components
const CellContentComponent = ({ order }: ReportSummaryCellContentProps) => (
  <div data-hc-name={dataHcName}>{order.orderTypeDescriptor.name}</div>
);

export const REPORT_SUMMARY_PRODUCT_TYPE_CONFIG =
  createReportSummaryTableCellConfig({
    CellContentComponent,
    tableHeaderName: 'Product Type',
  });
